import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getUser } from '@dealstack/frontend/shared/dataExchange/services/auth.service';

export const useDealUserPermissions = (dealId: string, hasDealViewerPermission: boolean) => {
	const getUserRequest = useQuery({
		queryKey: [API_PATHS.USER_GET],
		queryFn: () => getUser(),
		enabled: false,
		retry: false,
	});

	useEffect(() => {
		if (dealId && !hasDealViewerPermission) {
			void getUserRequest.refetch();
		}
	}, [dealId]);

	return {
		refetchUser: getUserRequest.refetch,
		isRefreshingPermissions: getUserRequest.isFetching && !hasDealViewerPermission,
	};
};
